export default __webpack_public_path__ + "static/media/saturn_texture.5200f189.jpg";